import {
  put,
  fork,
  call,
  select,
  takeLatest,
  delay,
  all,
  takeEvery,
} from 'redux-saga/effects';
import app from '../../app';
import {
  catchError,
  loadRecordListCompletion,
  loadArShopListCompletion,
  verifyCouponCompletion,
  loadAnalysisOrderListCompletion,
  loadAnalysisRecordListCompletion,
  loadMyPerformanceCompletion,
} from '../../actions';

function* watchLoadArShopListTrack() {
  yield takeEvery('LOAD_AR_SHOP_LIST', function*() {
    const options = {
      url: `/api/writeOff/myStore/list`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadArShopListCompletion(result.error, result.data));
  });
}

function* watchLoadRecordListTrack() {
  yield takeEvery('LOAD_RECORD_LIST', function*({ willReload }) {
    const { list, query } = yield select(state => state.mall.ar.master);
    let start = 0;

    if (!willReload && list) {
      start = list.length;
    }
    const options = {
      url: `/api/writeOff/myWriteOff/list?size=20&start=${start}&startDate=${query.startDate}&endDate=${query.endDate}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadRecordListCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  });
}

function* watchVerifyCouponTrack() {
  yield takeEvery('VERIFY_COUPON', function*({ query }) {
    const params = {
      channelCode: query.channelCode,
      couponNo: query.couponNo,
    };
    const options = {
      url: `/api/writeOff`,
      data: params,
      method: 'POST',
    };
    const result = yield call(app.httpFetch, options);
    yield put(verifyCouponCompletion(result.error, result.data));
  });
}

function* watchLoadMyPerformance() {
  yield takeEvery('LOAD_MY_PERFORMANCE', function*() {
    const options = {
      url: `/api/writeOff/myPerformance`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadMyPerformanceCompletion(result.error, result.data));
  });
}

export default function* arSaga() {
  yield all([
    fork(watchLoadArShopListTrack),
    fork(watchLoadRecordListTrack),
    fork(watchVerifyCouponTrack),
    fork(watchLoadMyPerformance),
  ]);
}
